import { render, staticRenderFns } from "./AddProductForm.vue?vue&type=template&id=ecb814d8"
import script from "./AddProductForm.vue?vue&type=script&lang=js"
export * from "./AddProductForm.vue?vue&type=script&lang=js"
import style0 from "./AddProductForm.vue?vue&type=style&index=0&id=ecb814d8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports